// Pure logic for the Plan/Prioritize popup — NO React/axios imports, so it's
// unit-testable under CRA jest (importing the component would pull in axios ESM).

// ⭐ A batch is in range if ANY of its ship_dates falls within [from, to]
// (inclusive). ISO date strings (YYYY-MM-DD) compare lexicographically.
export const batchShipsInRange = (shipDates: string[], from: string, to: string): boolean =>
  (shipDates || []).some(sd => sd >= from && sd <= to);

// ⭐ Reorder over the FULL (global) id sequence. The popup may show a FILTERED
// subset, but priority is GLOBAL — so a drag moves `draggedId` relative to
// `targetId` within the FULL list, and every other id (incl. hidden/out-of-range
// batches) keeps its relative order. Persisting this full list → priority = index
// never scrambles batches outside the visible window. (Audit 20 §5.3 / build 3-3 §2a.)
export const computeReorder = (
  fullIds: number[], draggedId: number, targetId: number, placeAfter: boolean,
): number[] => {
  if (draggedId === targetId) return fullIds;
  const without = fullIds.filter(id => id !== draggedId);
  let idx = without.indexOf(targetId);
  if (idx < 0) return fullIds;            // target not in set — no-op
  if (placeAfter) idx += 1;
  without.splice(idx, 0, draggedId);
  return without;
};
